import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { House, Buildings, UploadSimple, FileText, UsersThree, SignOut, Gear } from "@phosphor-icons/react";

const NAV = [
    { to: "/dashboard", label: "Group Overview", icon: House, testid: "nav-dashboard" },
    { to: "/companies", label: "Companies", icon: Buildings, testid: "nav-companies" },
    { to: "/upload", label: "Upload Report", icon: UploadSimple, testid: "nav-upload" },
    { to: "/reports", label: "Reports Archive", icon: FileText, testid: "nav-reports" },
    { to: "/team", label: "Team", icon: UsersThree, testid: "nav-team" },
    { to: "/settings", label: "Settings", icon: Gear, testid: "nav-settings" },
];

export default function Sidebar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    return (
        <aside className="w-64 shrink-0 bg-surface border-r border-rule flex flex-col h-screen sticky top-0" data-testid="sidebar">
            <div className="px-6 pt-6 pb-5 border-b border-rule flex items-center gap-3">
                <img
                    src="/jra-logo.png"
                    alt="Joseph Roberts Africa"
                    className="h-12 w-auto shrink-0"
                    data-testid="sidebar-logo"
                />
                <div className="min-w-0">
                    <div className="font-heading text-base font-extrabold tracking-tight leading-tight">Joseph Roberts</div>
                    <div className="overline text-[10px]">Reports Control Room</div>
                </div>
            </div>
            <nav className="flex-1 py-4">
                {NAV.map((n) => (
                    <NavLink
                        key={n.to}
                        to={n.to}
                        data-testid={n.testid}
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-6 py-3 text-sm border-l-2 transition-colors ${
                                isActive
                                    ? "border-ink bg-paper text-ink font-medium"
                                    : "border-transparent text-muted2 hover:text-ink hover:bg-paper"
                            }`
                        }
                    >
                        <n.icon size={18} weight="regular" />
                        <span>{n.label}</span>
                    </NavLink>
                ))}
            </nav>
            <div className="border-t border-rule p-4">
                <div className="overline mb-1">Signed in</div>
                <div className="text-sm font-medium text-ink truncate" data-testid="user-name">{user?.name}</div>
                <div className="text-xs text-muted2 truncate" data-testid="user-email">{user?.email}</div>
                <div className="overline mt-3 mb-2">Role · {user?.role}</div>
                <button
                    data-testid="logout-button"
                    onClick={async () => { await logout(); navigate("/login"); }}
                    className="w-full flex items-center justify-center gap-2 border border-ink text-ink rounded-sm py-2 text-xs font-medium hover:bg-ink hover:text-paper transition-colors"
                >
                    <SignOut size={14} /> Sign out
                </button>
            </div>
        </aside>
    );
}
